var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
    _vm.showTranscriptPopover
      ? _c(
          "div",
          {
            key: "popover",
            staticClass: "t-player__popover t-player__popover--4",
          },
          [
            _vm.loader
              ? _c(
                  "div",
                  { staticClass: "t-search__loader t-player__popover--empty" },
                  [
                    _c("i", {
                      staticClass: "fas fa-circle-notch fa-fw fa-spin",
                    }),
                  ]
                )
              : [
                  !_vm.$isEmpty(_vm.transcripts)
                    ? [
                        _c("t-input", {
                          staticClass: "t-player__popover--input",
                          attrs: {
                            focus: true,
                            size: "small",
                            placeholder: "Search in video",
                            type: "search",
                          },
                          on: {
                            wheel: function ($event) {
                              return $event.target.blur()
                            },
                          },
                          model: {
                            value: _vm.transcriptValue,
                            callback: function ($$v) {
                              _vm.transcriptValue = $$v
                            },
                            expression: "transcriptValue",
                          },
                        }),
                        _vm._v(" "),
                        !_vm.$isEmpty(_vm.transcriptionList)
                          ? _c(
                              "ul",
                              _vm._l(
                                _vm.transcriptionList,
                                function (c, index) {
                                  return _c(
                                    "li",
                                    {
                                      key: index,
                                      staticClass: "t-cursor--pointer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.onTranscriptSelect(
                                            c.startTime
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "t-mar--r-mi" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.showTimestamp(c.startTime)
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "t-mar--t-no t-mar--b-no",
                                        },
                                        [_vm._v(_vm._s(c.text))]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "t-tc--white t-ta--center t-player__popover--empty",
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.$t(
                                        "generic.text.no_transcripts_found"
                                      )
                                    ) +
                                    "\n        "
                                ),
                              ]
                            ),
                      ]
                    : _c(
                        "div",
                        {
                          staticClass: "t-ta--center t-player__popover--empty",
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$t("generic.text.no_transcripts_found")
                              ) +
                              "\n      "
                          ),
                        ]
                      ),
                ],
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }